import { render, staticRenderFns } from "./SectionSeverityFrom2025.vue?vue&type=template&id=542fe9ce"
import script from "./SectionSeverityFrom2025.vue?vue&type=script&lang=ts"
export * from "./SectionSeverityFrom2025.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports